// ✅ File: src/components/Setup/Escalation/NotificationChannels.js
// Added on 2025-11-10 — Notification channel configuration screen

import React from "react";

export default function NotificationChannels() {
  return (
    <div className="p-4">
      <h2 className="text-xl fw-bold mb-3">📡 Notification Channels</h2>
      <p>
        Manage and configure notification channels such as Email, SMS, and In-App alerts.
      </p>
    </div>
  );
}
